import { Flex, Link, Space, Spacing } from '@billy/design-system'
import { useParams } from 'react-router'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { getOrganizationViewUrl } from '../../../../../../utils/routing/getOrganizationViewUrl'
import { useVatDeclarations } from '../../../../context/vatDeclarationsContext'
import { useVatDeclarationsRoutes } from '../../../../context/vatDeclarationsRouteContext'
import { VatDeclarationsParams } from '../../../../types/vatDeclarationsParams'
import { useVatDeclarationsCorrectionMessage } from '../../hooks/useVatDeclarationsCorrectionMessage'

export const CorrectionBannerMessage = () => {
  const { organization } = useUserOrganization()
  const { unsettledCorrections } = useVatDeclarations()
  const { vatDeclarationId } = useParams<VatDeclarationsParams>()
  const { countryCorrectionMessage } = useVatDeclarationsCorrectionMessage()
  const vatDeclarationsRoutes = useVatDeclarationsRoutes()

  const unsettledCorrectionsData =
    unsettledCorrections?.map(({ id, periodText }) => {
      const correctionUrl = getOrganizationViewUrl(
        organization?.url,
        vatDeclarationsRoutes.getViewVatDeclarationRoute(id),
      )

      return {
        id,
        periodText,
        correctionUrl,
      }
    }) || []

  const isListViewOpen = !vatDeclarationId

  return (
    <>
      {countryCorrectionMessage}
      <Space size="s8" />
      {isListViewOpen && (
        <Flex gap={Spacing.S8} flexWrap="wrap">
          {unsettledCorrectionsData?.map(({ correctionUrl, id, periodText }) => (
            <Link to={correctionUrl} key={id}>
              {periodText}
            </Link>
          ))}
        </Flex>
      )}
    </>
  )
}
